<template>
    <transition appear name="fade" mode="out-in">
        <router-view :key="$route.fullPath"/>
    </transition>
</template>

<script>
export default {
    name: 'Main',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {

    },
    methods: {},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue